import { Route, Routes } from "react-router-dom";
import Layout from "./layout";
import Home from "../pages/home/home";
import Members from "../pages/members/members";
import Employees from "../pages/employees/employees/employees";
import OneEmployee from "../pages/employees/oneEmployee/oneEmployee";
import AttendanceAndLeave from "../pages/employees/attendanceAndLeave/attendanceAndLeave";
import Salaries from "../pages/employees/salaries/salaries";
import Vacations from "../pages/employees/vacations/vacations";
import Activities from "../pages/events/activities";
import OneActivity from "../pages/events/oneActivity/oneActivity";
import AddActivity from "../pages/events/addActivity/addActivity";
import EditActivity from "../pages/events/editActivity/editActivity";
import Settings from "../pages/settings/settings";
import Reports from "../pages/reports/reports";
import Store from "../pages/store/store";
import AddProduct from "../pages/store/addProduct/addProduct";
import EditProduct from "../pages/store/editProduct.jsx/editProduct";

const Routers = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="/members" element={<Members />} />
          <Route path="/employees" element={<Employees />} />
          <Route path="/employees/:id" element={<OneEmployee />} />
          <Route path="/activities" element={<Activities />} />
          <Route path="/activities/:id" element={<OneActivity />} />
          <Route path="/activities/add" element={<AddActivity />} />
          <Route path="/activities/edit" element={<EditActivity />} />
          <Route path="/store" element={<Store />} />
          <Route path="/store/:id" element={<EditProduct />} />
          <Route path="/store/add" element={<AddProduct />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/employees/attendance" element={<AttendanceAndLeave />} />
          <Route path="/employees/salaries" element={<Salaries />} />
          <Route path="/employees/leaves" element={<Vacations />} />
        </Route>
      </Routes>
    </>
  );
};

export default Routers;
